import { render, staticRenderFns } from "./NewGameUpload.vue?vue&type=template&id=6de84b37&scoped=true&"
import script from "./NewGameUpload.vue?vue&type=script&lang=js&"
export * from "./NewGameUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de84b37",
  null
  
)

export default component.exports